import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';
import { AdsBackButton, ContextToolbar } from '../ads';
import { useLanguage } from '../../contexts/LanguageContext';
import { translateWithVars } from '../../utils/i18n/translateWithVars';
import '../../styles/dashboard/dashboard-family.css';

/**
 * Dashboard-family context toolbar — back to home + module title + actions.
 * Shell Target Spec v1.0: single context strip (no separate page header layer).
 */
const DashboardFamilyHeader = ({
  title,
  subtitle,
  eyebrow,
  meta,
  actions,
  center,
  className = '',
  sticky = true,
  showBack = true,
  leading,
}) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const td = (key, vars) => translateWithVars(t(`managerDashboard.${key}`), vars);

  const goDashboard = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <ContextToolbar
      sticky={sticky}
      className={['dashboard-family-header', className].filter(Boolean).join(' ')}
      leading={
        leading !== undefined
          ? leading
          : showBack
            ? (
              <AdsBackButton
                className="dashboard-family-header__back"
                onClick={goDashboard}
                aria-label={td('backToDashboardAria')}
                title={td('backToDashboardAria')}
              >
                <LayoutDashboard
                  size={15}
                  strokeWidth={1.85}
                  aria-hidden
                  className="dashboard-family-header__back-icon"
                />
                <span>{td('backToDashboard')}</span>
              </AdsBackButton>
            )
            : null
      }
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
      meta={meta}
      center={center}
      actions={actions}
      titleAs="h1"
    />
  );
};

export default DashboardFamilyHeader;
